/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量22
 * @export
 * @interface Col22
 */
export interface Col22 {
}

/**
 * Check if a given object implements the Col22 interface.
 */
export function instanceOfCol22(value: object): value is Col22 {
    return true;
}

export function Col22FromJSON(json: any): Col22 {
    return Col22FromJSONTyped(json, false);
}

export function Col22FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col22 {
    return json;
}

export function Col22ToJSON(json: any): Col22 {
    return Col22ToJSONTyped(json, false);
}

export function Col22ToJSONTyped(value?: Col22 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

